var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-divider'),_c('v-list',_vm._l((_vm.links),function(ref){
var icon = ref[0];
var text = ref[1];
var link = ref[2];
return _c('v-list-item',{key:icon,attrs:{"link":"","to":link}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v(_vm._s(icon))])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(text))])],1)],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }